import React, { useState, useEffect } from "react";
import Select from 'react-select';
import GoogleMapReact from 'google-map-react';
import { useTranslation } from 'react-i18next';
import filesService from '../../services/file.service';
import { sourceUrl, googleApiKey } from '../../environment';
import { createMarkers } from '../../util';
import { customStyles, DropdownIndicator } from '../shared/selectStyle';
import './style.css';
import MapMore from "./mapMore";
const markerGoogle = {
  position: 'absolute',
  width: '40px',
  height: '40px',
  left: '-20px',
  top: '-40px'
}

const DEFAULT_ZOOM = 14
const ZOOM_DISTANCE_RATIO = 0.000002

const ZOOM_RATIO = {
  20: 1128.497220,
  19: 2256.994440,
  18: 4513.988880,
  17: 9027.977761,
  16: 18055.955520,
  15: 36111.911040,
  14: 72223.822090,
  13: 144447.644200,
  12: 288895.288400,
  11: 577790.576700,
  10: 1155581.153000,
  9: 2311162.307000,
  8: 4622324.614000,
  7: 9244649.227000,
  6: 18489298.450000,
  5: 36978596.910000,
  4: 73957193.820000,
  3: 147914387.600000,
  2: 295828775.300000,
  1: 591657550.500000
}

const _returnImages = (images) => images.map((imageId) => <img className="map-image-preview" src={sourceUrl + imageId } alt={imageId} />)

const MarkerWithContentHints = ({ locations = [] }) => {
  return locations.map(({ address, username, _id, ext, filename, images = [] }) =>
    (
      <div key={"merged - " + _id} className="hint-items">
        <div>
          <h4>{address}</h4>
          <p>{username}</p>
        </div>
        {_returnImages(images)}
      </div>
    )
  )
}


const MarkerWithContentList = ({ count, locations, showMore }) => {

  return (<div className="hint-list" onClick={() => { showMore(locations) }}>
    <h4>There is {count} images on this location.</h4>
    <h6>View all </h6>
  </div>
  )

}

const MarkerWithContent = (props) => {
  let hintClass;
  if (props.count === 2) {
    hintClass = "ht-two"
  }
  if (props.count === 1) {
    hintClass = "ht-one"
  }

  return (
    <div>
      <div className={(props.$hover ? 'greatPlaceStyleHover' : 'greatPlaceStyle')}>
        {props.count > 1 ? <div className="cluster-marker" style={{
          width: `${25 + props.count}px`,
          height: `${25 + props.count}px`
        }}>{props.count}</div> :
          <img style={markerGoogle} src="/assets/images/marker.png" alt="location" />}
        {props.count < 3 ? <div className={`hint__content ${hintClass}`}>
          <MarkerWithContentHints locations={props.locations} />
        </div> : <div className={`hint__content ht-more`}>
            <MarkerWithContentList locations={props.locations} count={props.count} showMore={props.showMore} />
          </div>}
      </div>
    </div>
  )
}

const GoogleMap = (props) => {

  let mergingDistance = ZOOM_DISTANCE_RATIO * ZOOM_RATIO[DEFAULT_ZOOM];

  const [markers, setMarkers] = useState(createMarkers(props.files, mergingDistance));

  useEffect(() => {
    setMarkers(createMarkers(props.files, mergingDistance))
  }, [props.files])

  const setMergingDistance = ({ zoom }) => {
    mergingDistance = ZOOM_DISTANCE_RATIO * ZOOM_RATIO[zoom];
    setMarkers(createMarkers(props.files, mergingDistance))
  }

  const center = {
    lat: props.files[0].location[1],
    lng: props.files[0].location[0]
  }

  const places = markers.map(marker => {
    const { locations, lat, lng, _id } = marker;
    let coords = { lng, lat }
    return (
      <MarkerWithContent
        key={_id}
        {...coords}
        locations={locations}
        count={locations.length}
        showMore={props.showMore}
      />
    );
  });

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: googleApiKey }}
        center={center}
        defaultZoom={DEFAULT_ZOOM}
        onChange={setMergingDistance}
        yesIWantToUseGoogleMapApiInternals
        className="google-wrapper-map"
        hoverDistance={40}
      >
        {places}
      </GoogleMapReact>
    </div>
  )
}

const mapsView = (props) => {
  const { t } = useTranslation();
  const [showMap, setShowMap] = useState(true);
  const [moreFiles, setMoreFiles] = useState([]);
  const [years, setYears] = useState(1);
  const [months, setMonths] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState({});
  const [selectedYear, setSelectedYear] = useState({});
  const [byYear, setByYear] = useState(false);

  useEffect(() => {
    getYears()
  }, []);

  const getYears = async () => {
    const years = await filesService.getYears();
    if (years.length > 0) {
      setYears(years);
      setSelectedYear(years[0]);
      await getMonth(years[0].value);

    }
  }
  const getMonth = async (year) => {
    const response = await filesService.listMonth(year);
    let prepareData = response.months.map(element => {
      return {
        value: element,
        label: element
      }
    });
    setMonths(prepareData);
    setSelectedMonth(prepareData[0]);
    await getAllFiles(year, response.months[0]);
  }

  const getAllFiles = async (year, month) => {
    const response = await filesService.getMapData(year, month);
    setFiles([...response]);
  }
  const handleChangeSelect = async (type, selected) => {
    if (type === 'month') {
      setSelectedMonth(selected);
    } else {
      setSelectedYear(selected);
      if (!byYear) { await getMonth(selected.value); }
    };

  }
  const handleSearch = async () => {
    let month = (!byYear ? selectedMonth.value : null)
    await getAllFiles(selectedYear.value, month);
  }
  const handleCheckboxChange = async  e => {
    setByYear(e.target.checked)
    if (!e.target.checked) { await getMonth(selectedYear.value); }
  };
  const showMore = (locations) => {
    setMoreFiles(locations);
    setShowMap(false);
  }
  const backToMap = () => {
    setShowMap(true);
  }
  return (
    <div className="space-around" >
      <div className={`hint__content ht-more`}>
        <div className="hint-list" >
          <h4>There is 11 images on this location.</h4>
          <h6>View all </h6>
        </div>
      </div>
      {showMap ? <div>
        {years.length > 0 ? <section className="filter-map-container">
          <div>
            <div className="by-year-checkbox">
              <input
                id="byYear"
                className="custom-checkbox "
                name="byYear"
                type="checkbox"
                checked={byYear}
                onChange={handleCheckboxChange} />
              <label htmlFor="byYear">
                {t('map.byYear')}
              </label>
            </div>

            <div className="map-filter-select">
              <Select
                styles={customStyles}
                components={{ DropdownIndicator }}
                value={selectedYear}
                onChange={(e) => handleChangeSelect('year', e)}
                options={years}
              />
            </div>
            {!byYear ?
              <div className="map-filter-select">
                <Select
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  value={selectedMonth}
                  onChange={(e) => handleChangeSelect('month', e)}
                  options={months}
                />
              </div> : null}
          </div>
          <button type="submit" className="btn btn-search" onClick={handleSearch}> <i className="fa fa-search" aria-hidden="true"></i></button>
        </section> : null}

        {files.length > 0 ? <GoogleMap files={files} showMore={showMore} /> : <div className="no-data-message">
          <h6>There isn't data to show</h6>
        </div>}
      </div> : <div className="map-more-container">
          <button type="submit" className="btn btn-white" onClick={backToMap}><i className="fa fa-angle-double-left" aria-hidden="true"></i>Back to map</button>
          <MapMore moreFiles={moreFiles} />
        </div>}

    </div>
  );
}

export default mapsView;



// WEBPACK FOOTER //
// ./src/components/mapPreview/mapVIew.js